import React from "react";
// import Spotify from '../../img/Spotify.svg';
// import AppleMusic from '../../img/AppleMusic.svg';
// import YandexMusic from '../../img/YandexMusic.svg';
// import VKMusic from '../../img/VKMusic.svg';
import policy from '../../files/alyonashvetspolicy.doc';
import oferta from '../../files/oferta.RTF';
import AlyonaShvetsLogo from "../../img/AlyonaShvetsLogo.png";
import Alyona from "../../img/Alyona34.png";
import DiscotechLogo from '../../img/discotech_logo_white.png';

import { ReactComponent as Spotify } from "../../img/Spotify.svg";
import { ReactComponent as AppleMusic } from "../../img/AppleMusic.svg";
import { ReactComponent as YandexMusic } from "../../img/YandexMusic.svg";
import { ReactComponent as VKMusic } from "../../img/VKMusic.svg";
import { DiscotechCredit } from "./DiscotechCredit";

export const Footer = ({ color }) => {
  const downloadFile = (doc, name) => {
    const link = document.createElement('a');
    link.href = doc;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <footer className={`flex flex-col items-center w-full ${color ? `bg-[${color}]` : 'bg-[#242424]'} xl:py-0`}>
      <div className="relative hidden xl:flex flex-col items-center xl:flex-row w-full max-w-screen-xl">
        
        <div className="h-full flex-1 items-center justify-center">
          <img
            src={AlyonaShvetsLogo}
            alt="bg"
            className="w-32 h-32 object-contain"
          />
          {/* <img
          src={DiscotechLogo}
          alt="Discotech Logo"
          className="w-[100px] h-[16px] object-contain mt-2"
        /> */}
        </div>
        
        <div className="flex flex-row justify-center items-center w-full xl:w-auto">
          <img
            src={Alyona}
            alt="AlenaAds"
            className="w-full max-w-[200px] h-auto object-contain"
          />
          <div className="flex flex-col space-y-2">
            <div className="flex flex-row items-center space-x-2">
              <a href="https://music.apple.com/ru/artist/%D0%B0%D0%BB%D1%91%D0%BD%D0%B0-%D1%88%D0%B2%D0%B5%D1%86/1445171738"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block w-[40%] h-[40%]">
                <AppleMusic className="w-full h-full text-white" />
              </a>
              <a href="https://music.yandex.ru/artist/6286764"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block w-[40%] h-[40%]">
                <YandexMusic className="w-full h-full text-white" />
              </a>
            </div>
            <div className="flex flex-row items-center space-x-2">
              <a href="https://share.boom.ru/artist/12677582?share_auth=0294f7528e809ccdbd811a61fafee0"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block w-[40%] h-[40%]">
                <VKMusic className="w-full h-full text-white" />
              </a>
              <a href="https://open.spotify.com/artist/7m9RH1V73dYjGv8RgGP39c"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block w-[40%] h-[40%]">
                <Spotify className="w-full h-full text-white" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="h-full flex-1 flex-col justify-between">
          
          <div className="flex flex-col text-right mb-4">
            <a className="text-[17px] font-bold text-white hover:underline cursor-pointer whitespace-pre-line"
              onClick={() => downloadFile(policy, 'alyonashvetspolicy.doc')}>
              {`Политика обработки\nперсональных данных`}
            </a>
            <a className="text-[17px] mt-2 font-bold text-white hover:underline cursor-pointer"
              onClick={() => downloadFile(oferta, 'oferta.RTF')}>
              Оферта и правила возврата товара
            </a>
          </div>
          
          <div className="flex flex-col text-right">
            <p className="whitespace-pre-line text-[#929292] text-[14px]">
              {`ИП Швецова Алёна Сергеевна\nИНН 744717497620\nОГРНИП 320745600065758`}
            </p>
          </div>
        </div>
      </div>
      <div className="mt-4 relative xl:hidden flex flex-col items-center justify-center xl:flex-row w-full max-w-screen-xl">
        
        <div className="h-full flex-1 items-center justify-center">
          <img
            src={AlyonaShvetsLogo}
            alt="bg"
            className="w-24 h-24 object-contain"
          />
        </div>
        
        <div className="h-full flex-1 flex-col justify-between mt-4">
          
          <div className="flex flex-col mb-4">
            <a className="text-[20px] font-bold text-center text-white hover:underline cursor-pointer"
              onClick={() => downloadFile(policy, 'alyonashvetspolicy.doc')}>
              Политика обработки персональных данных
            </a>
            <a className="text-[20px] font-bold text-center text-white hover:underline cursor-pointer"
              onClick={() => downloadFile(oferta, 'oferta.RTF')}>
              Оферта и правила возврата товара
            </a>
          </div>
          
          <div className="flex flex-col text-center">
            <p className="whitespace-pre-line text-[#929292]">
              {`ИП Швецова Алёна Сергеевна\nИНН 744717497620`}
            </p>
          </div>
        </div>
        
        <div className="flex flex-row justify-center items-center mt-2 w-full">
          <div className="flex flex-col justify-center space-y-1 w-full">
            <div className="flex flex-col items-center space-y-1">
              <a href="https://music.apple.com/ru/artist/%D0%B0%D0%BB%D1%91%D0%BD%D0%B0-%D1%88%D0%B2%D0%B5%D1%86/1445171738"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block w-[25%] h-[25%]">
                <AppleMusic className="w-full h-full" />
              </a>
              <a href="https://music.yandex.ru/artist/6286764"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block w-[25%] h-[25%]">
                <YandexMusic className="w-full h-full" />
              </a>
            </div>
            <div className="flex flex-col items-center space-y-1">
              <a href="https://share.boom.ru/artist/12677582?share_auth=0294f7528e809ccdbd811a61fafee0m"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block w-[25%] h-[25%]">
                <VKMusic className="w-full h-full" />
              </a>
              <a href="https://open.spotify.com/artist/7m9RH1V73dYjGv8RgGP39c"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block w-[25%] h-[25%]">
                <Spotify className="w-full h-full" />
              </a>
            </div>
          </div>
        </div>
      </div>
<div className="w-full border-t border-white/10">
  <div className="mx-auto max-w-screen-xl px-6 py-4 flex flex-col-reverse items-center gap-3 md:flex-row md:justify-between">
    <p className="text-[13px] text-[#5f5f5f]">© {new Date().getFullYear()} Алёна Швец</p>
    <DiscotechCredit />
  </div>
</div>
    </footer>
  );
};